import React from 'react';

export const dashboardRoute = '/dashboard';

export function Dashboard(props) {
	return <div>test</div>;
}
